import React, { useCallback, useEffect, useState } from 'react';
import { Button, Spin } from 'antd';
import { useHistory } from 'react-router-dom';

import { buildRestUrl } from '@src/util/cloud-functions/restEndpoint';

import IntlMessages from 'util/IntlMessages';

import Logo from '../../Logo';
import styles from '../styles.module.less';

const updateSubscription = async (path, token) => {
  const response = await fetch(buildRestUrl(path, { token }), { method: 'POST' });

  if (!response.ok) {
    throw new Error(`Subscription request failed with status ${response.status}`);
  }
};

const UnSubscribed = ({ token }) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [unSubscribeSucessful, setUnSubscribeSucessful] = useState(false);

  const subscribing = useCallback(
    () => updateSubscription('/subscription/subscribe', token),
    [token],
  );
  const unsubscribing = useCallback(
    () => updateSubscription('/subscription/unsubscribe', token),
    [token],
  );

  const onSubscribing = useCallback(async () => {
    if (!token) {
      history.push('/subscriptions/notifications/subscribedError');
      return;
    }
    setLoading(true);

    try {
      await subscribing();
      history.push('/subscriptions/notifications/subscribed');
    } catch {
      history.push('/subscriptions/notifications/subscribedError');
    } finally {
      setLoading(false);
    }
  }, [history, token, subscribing]);

  useEffect(() => {
    if (!token) {
      history.push('/subscriptions/notifications/unsubscribedError');
      return;
    }

    setLoading(true);

    const unsubscribe = async () => {
      try {
        await unsubscribing();
        setUnSubscribeSucessful(true);
      } catch {
        history.push('/subscriptions/notifications/unsubscribedError');
      } finally {
        setLoading(false);
      }
    };

    unsubscribe();
  }, [history, token, unsubscribing]);

  if (loading) return <Spin />;

  return (
    unSubscribeSucessful && (
      <div className="gx-flex-row gx-justify-content-center gx-pt-4">
        <div className="gx-flex-column gx-justify-content-center">
          <div className="gx-flex-column gx-align-items-center gx-pb-4">
            <Logo />
            <div className={styles.bodyContainer}>
              <p className={styles.bodyTitle}>
                <IntlMessages id="subscriptions.notification.unsubscribed.title" />
              </p>
              <p className={styles.subTitle}>
                <IntlMessages id="subscriptions.notification.unsubscribed.subTitle" />
              </p>
            </div>
          </div>
          <div className={styles.buttonC}>
            <Button onClick={() => history.push('/signin')} block type="primary">
              <IntlMessages id="subscriptions.notification.enter" />
            </Button>
            <Button onClick={onSubscribing} block danger>
              <IntlMessages id="subscriptions.notification.subscribed.cancel" />
            </Button>
          </div>
        </div>
      </div>
    )
  );
};

export default UnSubscribed;
